var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let ColoredCard = class ColoredCard extends LitElement {
    constructor() {
        super(...arguments);
        this.color = '#ffffff';
        this.alpha = 1.0;
        this.size = 'medium';
    }
    updated(changedProperties) {
        if (changedProperties.has('color') || changedProperties.has('alpha')) {
            const rgb = this.hexToRgb(this.color);
            if (rgb) {
                this.style.setProperty('--card-color-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
            }
            this.style.setProperty('--card-alpha', this.alpha.toString());
        }
    }
    hexToRgb(hex) {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b);
        const regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
        const result = regex.exec(hex);
        return result
            ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16),
            }
            : null;
    }
    render() {
        return html `
        <basic-card
            .size=${this.size}
        ><slot></slot></basic-card>
        `;
    }
};
ColoredCard.styles = css `
        basic-card {
            background-color: rgba(var(--card-color-rgb, 255, 255, 255), var(--card-alpha, 1.0));
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            padding: 16px;
        }
    `;
__decorate([
    property({ type: String })
], ColoredCard.prototype, "color", void 0);
__decorate([
    property({ type: Number })
], ColoredCard.prototype, "alpha", void 0);
__decorate([
    property({ type: String })
], ColoredCard.prototype, "size", void 0);
ColoredCard = __decorate([
    customElement('colored-card')
], ColoredCard);
export { ColoredCard };
//# sourceMappingURL=ColoredCard.js.map